import { useParams } from "react-router";

import { TabSideNavigation } from "@shared";
import { TabSideNavigationItem } from "@shared";

import { useActiveMasterDataTab } from "@/pages/clients/client/hooks/useClientTabs";
import { ClientByIdParams, ClientMasterDataTab, clientPath } from "@/router/ClientRoutes";
import { useTranslation } from "@/translations";

export function ClientMasterDataNavigation() {
  const { t } = useTranslation();
  const { id } = useParams<ClientByIdParams>();
  const activeView = useActiveMasterDataTab();

  if (!id) {
    return null;
  }

  const items: TabSideNavigationItem[] = [
    {
      key: ClientMasterDataTab.PersonalData,
      label: t("clients.client.masterData.personalData.label"),
      to: clientPath.byMasterDataTab({ id, tab: ClientMasterDataTab.PersonalData }),
    },
    {
      key: ClientMasterDataTab.GoalsResults,
      label: t("clients.client.masterData.goalsResults"),
      to: clientPath.byMasterDataTab({ id, tab: ClientMasterDataTab.GoalsResults }),
    },
    {
      key: ClientMasterDataTab.MeasuresCauses,
      label: t("clients.client.masterData.measuresCauses"),
      to: clientPath.byMasterDataTab({ id, tab: ClientMasterDataTab.MeasuresCauses }),
    },
    {
      key: ClientMasterDataTab.StatusCounselor,
      label: t("clients.client.masterData.statusCounselor"),
      to: clientPath.byMasterDataTab({ id, tab: ClientMasterDataTab.StatusCounselor }),
    },
    {
      key: ClientMasterDataTab.VolunteerAssignment,
      label: t("clients.client.masterData.volunteerAssignment"),
      to: clientPath.byMasterDataTab({ id, tab: ClientMasterDataTab.VolunteerAssignment }),
    },
    {
      key: ClientMasterDataTab.ClientAccess,
      label: t("clients.client.masterData.clientAccess"),
      to: clientPath.byMasterDataTab({ id, tab: ClientMasterDataTab.ClientAccess }),
    },
  ];

  return <TabSideNavigation items={items} activeKey={activeView} />;
}
